// Vue 3
import { createApp, defineAsyncComponent } from 'vue'
import App from './App.vue'

// Router & Store
import router from './router'
import store from './store'

// Bootstrap
import { createBootstrap } from 'bootstrap-vue-next'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-vue-next/dist/bootstrap-vue-next.css'

// Notifications
import AWN from "awesome-notifications"
import "awesome-notifications/dist/style.css"
import VueApexCharts from 'vue3-apexcharts'

// jQuery
// import $ from 'jquery'
// window.jQuery = window.$ = $

// Useful Libraries
import _ from 'lodash'
window._ = _

// Vue Select
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'

// Timepicker
// import VueTimepicker from 'vue2-timepicker'
// import 'vue2-timepicker/dist/VueTimepicker.css'

// i18n
import { createI18n } from 'vue-i18n'
import messages from '@/lang/messages.js'


// Global Helper Mixin
import helperMixin from '@/shared/helperMixin'

// dayjs (replaces vue-moment)
import dayjs from 'dayjs'
import isoWeek from 'dayjs/plugin/isoWeek'

dayjs.extend(isoWeek)

import { vOnClickOutside } from '@vueuse/components'
import { vMaska } from 'maska/vue'

import VCalendar from 'v-calendar';
import 'v-calendar/style.css';

import { VueDatePicker }  from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';


///////////////////////////////////////
///////////// COMPONENTS //////////////
///////////////////////////////////////

const LoaderScreen = defineAsyncComponent(() => import('@/modules/shared/components/LoaderScreen'))
const FieldEditButton = defineAsyncComponent(() => import('@/modules/clients/common/views/FieldEditButton'))
const ClientTextInput = defineAsyncComponent(() => import('@/modules/clients/common/views/ClientTextInput'))
const ClientSelectInput = defineAsyncComponent(() => import('@/modules/clients/common/views/ClientSelectInput'))
const ClientMultiSelectInput = defineAsyncComponent(() => import('@/modules/clients/common/views/ClientMultiSelectInput'))
const FormTextInput = defineAsyncComponent(() => import('@/modules/shared/components/FormTextInput'))
const FormSelectInput = defineAsyncComponent(() => import('@/modules/shared/components/FormSelectInput'))
const FormMultiSelectInput = defineAsyncComponent(() => import('@/modules/shared/components/FormMultiSelectInput'))
const ClientList = defineAsyncComponent(() => import('@/modules/clients/common/views/ClientList'))
const ClientSearch = defineAsyncComponent(() => import('@/modules/clients/views/ClientSearch'))
const ClientDetails = defineAsyncComponent(() => import('@/modules/clients/views/ClientDetails'))
const CompanyAvatar = defineAsyncComponent(() => import('@/modules/shared/components/CompanyAvatar'))
const PageNoData = defineAsyncComponent(() => import('@/modules/shared/components/PageNoData'))
const ClientNotes = defineAsyncComponent(() => import('@/modules/notes/common/views/ClientNotes'))
const NoteButton = defineAsyncComponent(() => import('@/modules/notes/common/views/NoteButton'))
const Editor = defineAsyncComponent(() => import('@/modules/shared/components/Editor'))
const Paginate = defineAsyncComponent(() => import('@/modules/shared/components/Paginate'))
const CompanyFilter = defineAsyncComponent(() => import('@/modules/shared/components/CompanyFilter'))
const ProcessorFilter = defineAsyncComponent(() => import('@/modules/shared/components/ProcessorFilter'))
const FundedFilter = defineAsyncComponent(() => import('@/modules/shared/components/FundedFilter'))
const FulfillmentFilter = defineAsyncComponent(() => import('@/modules/shared/components/FulfillmentFilter'))
const EntityFilter = defineAsyncComponent(() => import('@/modules/shared/components/EntityFilter'))
const AgentFilter = defineAsyncComponent(() => import('@/modules/shared/components/AgentFilter'))
const LastActionFilter = defineAsyncComponent(() => import('@/modules/shared/components/LastActionFilter'))
const ReboardedFilter = defineAsyncComponent(() => import('@/modules/shared/components/ReboardedFilter'))
const StatusFilter = defineAsyncComponent(() => import('@/modules/shared/components/StatusFilter'))
const CallLogTrainerFilter = defineAsyncComponent(() => import('@/modules/shared/components/CallLogTrainerFilter'))
const OtherFilter = defineAsyncComponent(() => import('@/modules/shared/components/OtherFilter'))
const SelectedFilter = defineAsyncComponent(() => import('@/modules/shared/components/SelectedFilter'))
const OnlineStatusBadge = defineAsyncComponent(() => import('@/modules/shared/components/OnlineStatusBadge'))
const RoleFilter = defineAsyncComponent(() => import('@/modules/shared/components/RoleFilter'))
const SingleStatusFilter = defineAsyncComponent(() => import('@/modules/shared/components/SingleStatusFilter'))
const TerminalDeployFilter = defineAsyncComponent(() => import('@/modules/shared/components/TerminalDeployFilter'))
const AccountingSort = defineAsyncComponent(() => import('@/modules/accounting/common/views/AccountingSort'))
const AssignCloser = defineAsyncComponent(() => import('@/modules/shared/components/AssignCloser'))
const EditClientStatusOption = defineAsyncComponent(() => import('@/modules/shared/components/EditClientStatusOption'))
const EditTicketStatusOption = defineAsyncComponent(() => import('@/modules/shared/components/EditTicketStatusOption'))
const EditClientTerminalStatus = defineAsyncComponent(() => import('@/modules/shared/components/EditClientTerminalStatus'))
const ClientOrders = defineAsyncComponent(() => import('@/modules/orders/views/ClientOrders'))
const OrderButton = defineAsyncComponent(() => import('@/modules/shared/components/OrderButton'))
const FileUpload = defineAsyncComponent(() => import('@/modules/shared/components/FileUpload.vue'))
const CustomTable = defineAsyncComponent(() => import('@/modules/shared/components/CustomTable'))
const TrainerList = defineAsyncComponent(() => import('@/modules/shared/components/TrainerList'))
const CSAgentList = defineAsyncComponent(() => import('@/modules/shared/components/CSAgentList'))
const AssignAgentsForClient = defineAsyncComponent(() => import('@/modules/shared/components/AssignAgentsForClient'))
const DocusignPanel = defineAsyncComponent(() => import('@/modules/orders/components/DocusignPanel'))
const ClientReviewList = defineAsyncComponent(() => import('@/modules/reviews/views/ClientReviewList'))
const LeadInfo = defineAsyncComponent(() => import('@/modules/shared/components/LeadInfo'))
const MyCallback = defineAsyncComponent(() => import('@/modules/shared/components/MyCallback'))
const LatestCall = defineAsyncComponent(() => import('@/modules/shared/components/LatestCall'))
const DbaPhones = defineAsyncComponent(() => import('@/modules/shared/components/DbaPhones'))
const HotListButton = defineAsyncComponent(() => import('@/modules/shared/components/HotListButton'))
const SuggestAddress = defineAsyncComponent(() => import('@/modules/shared/components/SuggestAddress'))
const ClearFilterButton = defineAsyncComponent(() => import('@/modules/shared/components/ClearFilterButton'))
const PreviousAgentFilter = defineAsyncComponent(() => import('@/modules/shared/components/PreviousAgentFilter'))
const StatCard = defineAsyncComponent(() => import('@/modules/shared/components/StatCard'))
const VoipCallButton = defineAsyncComponent(() => import('@/modules/clients/common/views/VoipCallButton'))
const TableClientDetail = defineAsyncComponent(() => import('@/modules/shared/components/TableClientDetail'))
const CSTaskButton = defineAsyncComponent(() => import('@/modules/customer_service/common/components/CSTaskButton'))

// ERROR HANDLERS FIRST (before createApp)
window.addEventListener('vite:preloadError', (event) => {
  console.log('Deployment detected, reloading...')
  window.location.reload()
})

// 2. Catches synchronous module load errors (the MIME type error you showed)
window.addEventListener('error', (event) => {
  const message = event.message || ''
  if (message.includes('Failed to fetch dynamically imported module') ||
      message.includes('Expected a JavaScript module script') ||
      message.includes('Failed to load module script')) {
    console.log('Chunk load error detected, reloading...')
    window.location.reload()
  }
})

// 3. Catches async/promise-based import failures
window.addEventListener('unhandledrejection', (event) => {
  const message = event.reason?.message || ''
  if (message.includes('Failed to fetch dynamically imported module') ||
      message.includes('Expected a JavaScript module script')) {
    console.log('Module import error detected, reloading...')
    window.location.reload()
  }
})

///////////////////////////////////////
///////////// SETTINGS ////////////////
///////////////////////////////////////

const savedLocale = localStorage.getItem('locale') || 'en'

const i18n = createI18n({
  locale: savedLocale,
  fallbackLocale: 'en',
  messages,
})


///////////////////////////////////////
//////// CREATE APP ///////////////////
///////////////////////////////////////

const app = createApp(App)

///////////////////////////////////////
//////// GLOBAL PROPERTIES ////////////
///////////////////////////////////////

app.config.globalProperties._ = _
app.config.globalProperties.$dayjs = dayjs

///////////////////////////////////////
//////// USE PLUGINS //////////////////
///////////////////////////////////////

app.use(router)
app.use(store)
app.use(createBootstrap())
app.use(i18n)

app.mixin(helperMixin)

app.directive('click-outside', vOnClickOutside)
app.directive('maska', vMaska)

app.use(VCalendar, {})
app.component('VueDatePicker', VueDatePicker);


// awesome notifications setup
import "awesome-notifications/dist/style.css"
const awn = new AWN({ position: "top-right" })
app.config.globalProperties.$awn = awn
window.$awn = awn

///////////////////////////////////////
//////// GLOBAL COMPONENTS ////////////
///////////////////////////////////////

app.component('field-edit-button', FieldEditButton)
app.component('loader-screen', LoaderScreen)
app.component('client-text-input', ClientTextInput)
app.component('client-select-input', ClientSelectInput)
app.component('client-multi-select-input', ClientMultiSelectInput)
app.component('form-text-input', FormTextInput)
app.component('form-select-input', FormSelectInput)
app.component('form-multi-select-input', FormMultiSelectInput)
app.component('client-list', ClientList)
app.component('client-search', ClientSearch)
app.component('client-details', ClientDetails)
app.component('v-select', vSelect)
app.component('CompanyAvatar', CompanyAvatar)
app.component('PageNoData', PageNoData)
app.component('ClientNotes', ClientNotes)
app.component('NoteButton', NoteButton)
app.component('AccountingSort', AccountingSort)
app.component('AssignCloser', AssignCloser)
app.component('EditClientStatusOption', EditClientStatusOption)
app.component('EditTicketStatusOption', EditTicketStatusOption)
app.component('EditClientTerminalStatus', EditClientTerminalStatus)
app.component('ClientOrders', ClientOrders)
app.component('OrderButton', OrderButton)
app.component('FileUpload', FileUpload)
app.component('CustomTable', CustomTable)
app.component('TrainerList', TrainerList)
app.component('CSAgentList', CSAgentList)
app.component('AssignAgentsForClient', AssignAgentsForClient)
app.component('DocusignPanel', DocusignPanel)
app.component('ClientReviewList', ClientReviewList)
app.component('LeadInfo', LeadInfo)
app.component('MyCallback', MyCallback)
app.component('LatestCall', LatestCall)
app.component('DbaPhones', DbaPhones)
app.component('HotListButton', HotListButton)
app.component('Editor', Editor)
app.component('Paginate', Paginate)
app.component('CompanyFilter', CompanyFilter)
app.component('SingleStatusFilter', SingleStatusFilter)
app.component('TerminalDeployFilter', TerminalDeployFilter)
app.component('ProcessorFilter', ProcessorFilter)
app.component('FundedFilter', FundedFilter)
app.component('FulfillmentFilter', FulfillmentFilter)
app.component('SelectedFilter', SelectedFilter)
app.component('OnlineStatusBadge', OnlineStatusBadge)
app.component('RoleFilter', RoleFilter)
app.component('EntityFilter', EntityFilter)
app.component('AgentFilter', AgentFilter)
app.component('LastActionFilter', LastActionFilter)
app.component('ReboardedFilter', ReboardedFilter)
app.component('StatusFilter', StatusFilter)
app.component('CallLogTrainerFilter', CallLogTrainerFilter)
app.component('OtherFilter', OtherFilter)
// app.component('VueTimepicker', VueTimepicker)
app.component('SuggestAddress', SuggestAddress)
app.component('ClearFilterButton', ClearFilterButton)
app.component('PreviousAgentFilter', PreviousAgentFilter)
app.component('apexchart', VueApexCharts)
app.component('StatCard', StatCard)
app.component('VoipCallButton', VoipCallButton)
app.component('TableClientDetail', TableClientDetail)
app.component('CSTaskButton', CSTaskButton)

///////////////////////////////////////
//////// MOUNT APP ////////////////////
///////////////////////////////////////

app.mount('#app')
